import React from 'react';
import { useClerk, SignInButton, SignOutButton } from '@clerk/clerk-react';
import { useSearch } from '../../store/context/SearchContext';

export const GoogleAuth = ({ itemsCount, cmsData}) => {
  const { user } = useClerk();
  const { productsList, userCart} = useSearch()

// const handleClearCart = () => {
//   clearCart()
// }

  const checkUserInfo = async () => {
    console.log("===========================user info from google auth", user)
    // const userInfo = await fetch("/.netlify/functions/userHandler", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json",
    //    },
    //   body: JSON.stringify({
    //     request_type: "get_user_info",
    //      user_info: user
    //     })
    // })
    // const find_res = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`);
    const find_res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users?filters[u_id][$eq]=${user.id}`);
    const data = await find_res.json();
    console.log("+++++++++++>>>>>>>>>>>>>>>>>", data.data.length === 0);
    if(data.data.length !== 0 && user.id === data.data[0].u_id){
         console.log("+++++++++++>>>>>>>>>>>>>>>>> line 28" , data);
         console.log("+++++++++++>>>>>>>>>>>>>>>>> line 29" , data.data[0].u_id);
         console.log("+++++++++++>>>>>>>>>>>>>>>>> line 30" , data.data[0].cart);
        
         data.data[0].cart.map((item)=> console.log("+++++++++++>>>>>>>>>>>>>>>>> line 33" , item.name) )
         let cartItems 
         cartItems = data.data[0].cart ? cartItems = data.data[0].cart : ""
   
       if(data.data[0].cart && data.data[0].cart?.length > 0 && productsList && productsList.length !== cartItems.length){
         userCart(cartItems)
         // handleClearCart()
         //  addItem(cartItems)
       }
       if(cartItems !== "" && productsList && cartItems.length === productsList.length){
       // console.log("the productsList from google auth", productsList)
       itemsCount()
       
       }
   

    }   
    if (data.data.length === 0) {
      // console.log("+++++++++++ create new user with id ", id);
      // //------------> Create new User throug the strAPI Cms if not exsist
      // const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/auth-public-users`, {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth-public-users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            first_name: user.firstName,
            email: user.primaryEmailAddress.emailAddress,
            last_name: user.lastName,
            u_id: user.id,
            image_url: user.imageUrl,
            // "cart" : products
          },
        }),
      });
      const data = await res.json();
      console.log("user handler line 57", data);      
    }
    
    }
    
   
   
    


  if(user){
    checkUserInfo()
  console.log("user info 90 ",productsList );

  }

  return (
    <div className="flex flex-col items-center justify-center w-full">
      {!user ? (
        <SignInButton mode="modal" redirecturl="/">
          <button className="w-full bg-blue-400 text-gray-800 font-semibold py-2 px-4 border border-blue-800 rounded-lg shadow-sm hover:bg-blue-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            <span className="flex items-center justify-center">
              <svg className="w-2 h-5 text-center" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            
              </svg>
              {cmsData}
            </span>
          </button>
        </SignInButton>
      ) : (
        <div className="flex flex-col items-center w-full space-y-2">
          <p className="bg-gray-500 text-white font-semibold py-2 px-4 rounded w-full text-center">
            welcome {user.firstName}!

          </p>
          <SignOutButton className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded w-full">
            signOut
          </SignOutButton>
        </div>
      )}
      {/* <button className="bg-orange-400 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded w-full" onClick={handleClearCart}>Clear Cart</button> */}
    </div>
  );
};
